module.exports = __webpack_public_path__ + "static/media/edenred_black.24d95578.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/edenred_black.woff
// module id = 260
// module chunks = 1